import * as Sentry from '@sentry/browser';
import * as constants from '@/constants';
import i18n from '@/settings/i18n';
import { useFlashMessenger } from './useFlashMessenger';
import { useCallback } from 'react';

export const useApiErrorHandler = () => {
  const { flashError } = useFlashMessenger();

  const apiErrorHandler = useCallback(
    (err: any) => {
      if (
        err.response &&
        err.response.status === 401 &&
        err.response.data &&
        err.response.data.error === constants.INVALID_ACCESS_TOKEN_ERROR
      ) {
        flashError(i18n.t('ui.error.unexpected_and_login'));
      } else {
        Sentry.captureException(err);

        flashError(i18n.t('ui.error.unexpected'));
      }
    },
    [flashError],
  );

  return { apiErrorHandler };
};
